import{camelToDash as r}from"../../render/dom/utils/camel-to-dash.mjs.js";const a="framerAppearId",e="data-"+r("framerAppearId");export{e as optimizedAppearDataAttribute,a as optimizedAppearDataId};
